import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { resolveRoute } from "@/lib/guards";
import BrandLogo from "@/components/BrandLogo";

// Route-level gate. All gating precedence (auth > access_status > onboarding >
// admin) lives in resolveRoute (guards.js) — this component only applies it.
// The `requireOnboarding` prop is accepted for backward-compat but ignored;
// classification is derived from the path inside guards.js.
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg">
        <BrandLogo size="lg" className="animate-pulse-slow" />
      </div>
    );
  }

  const dest = resolveRoute({
    user,
    route: location.pathname + location.search,
  });
  if (dest) {
    return <Navigate to={dest} replace />;
  }

  return children;
}
